<template>
  <div v-if="profile">
    <div v-if="profile.avatar">
      <img
        class="rounded-full object-cover p-1"
        :class="size"
        :src="profile.avatar"
        alt="avatar"
      />
    </div>
    <div
      v-else
      class="relative inline-flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-[var(--p-primary-color)]"
    >
      <span class="text-uppercase font-medium">{{ avatarName }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';

export default defineNuxtComponent({
  props: {
    size: {
      default: 'size-10',
      required: false,
      type: String,
    },
  },
  computed: {
    ...mapState(useAuthStore, ['profile']),
    avatarName() {
      if (this.profile) {
        const initials =
          this.profile.name[0] +
          (this.profile.surname
            ? this.profile.surname[0]
            : this.profile.name[1]);
        return initials.toUpperCase(); // Uppercase yapılması
      }
      return '';
    },
  },
});
</script>

<style  scoped></style>
